module.exports = __webpack_public_path__ + "img/xls.dcd1e9bb.png";